import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { setDayjsLocale } from '../dayjs-config'

import enUS from './locales/en-US.json'
import zhCN from './locales/zh-CN.json'
import zhHK from './locales/zh-HK.json'

// Storage key for language preference
const STORAGE_KEY_LANGUAGE = 'orax_language'

// Get saved language or detect from browser
function getDefaultLanguage(): string {
  // Check localStorage first
  try {
    const saved = localStorage.getItem(STORAGE_KEY_LANGUAGE)
    if (saved && ['en-US', 'zh-CN', 'zh-HK'].includes(saved)) {
      return saved
    }
  } catch {
    // localStorage not available
  }

  // Detect from browser
  const browserLang = navigator.language
  if (browserLang.startsWith('zh')) {
    // zh-TW, zh-HK -> zh-HK; zh-CN, zh -> zh-CN
    return browserLang === 'zh-TW' || browserLang === 'zh-HK' ? 'zh-HK' : 'zh-CN'
  }

  return 'en-US'
}

i18n.use(initReactI18next).init({
  resources: {
    'en-US': { translation: enUS },
    'zh-CN': { translation: zhCN },
    'zh-HK': { translation: zhHK },
  },
  lng: getDefaultLanguage(),
  fallbackLng: 'en-US',
  interpolation: {
    escapeValue: false, // React already escapes
  },
})

// Set initial dayjs locale
setDayjsLocale(getDefaultLanguage())

// Save language preference when changed and sync dayjs locale
i18n.on('languageChanged', (lng) => {
  try {
    localStorage.setItem(STORAGE_KEY_LANGUAGE, lng)
  } catch {
    // localStorage not available
  }
  // Sync dayjs locale
  setDayjsLocale(lng)
})

export default i18n

// Export utility for language switching
export function changeLanguage(lang: string) {
  i18n.changeLanguage(lang)
}

export function getCurrentLanguage(): string {
  return i18n.language
}

export const supportedLanguages = [
  { value: 'en-US', label: 'English' },
  { value: 'zh-CN', label: '简体中文' },
  { value: 'zh-HK', label: '繁體中文' },
]
